export const formLevelsAndNodes = (levels, players, type, stageNumber) => {
	const formedNodesList = []
	let playersArray = players

	if (stageNumber === 1) {
		playersArray = players?.map((p, index) => {
			return { ...p, rating: index + 1 }
		})
	}

	const newLevels = levels?.map(lvl => {
		const newGroups = lvl?.groups?.map(grp => {
			const participants = grp?.nodes?.filter(node => node?.type === 'incoming')

			const formedParticipants = participants.map((node) => {
				let formedNode = []

				if (type === 'singles') {
					const participant = playersArray?.find((p) => p.uid === node?.player_uid)
					let name = '---'
					let rating = null

					if (participant?.formedName) {
						name = participant?.formedName
						rating = participant?.rating ? participant?.rating : node?.name
					} else if (!node?.disabled && !node?.bye && !node?.player_uid) {
						name = node?.name
						rating = null
					} else if (!node?.disabled && node?.bye) {
						name = '---'
						rating = '-'
					}

					formedNode = {
						placed: '',
						nodeUid: node?.uid,
						bye: node?.bye,
						disabled: node?.disabled,
						type: node?.type,
						playerUid: participant?.uid ? participant?.uid : null,
						orderNumber: node?.order_number,
						rating,
						name,
						groupName: grp.name
					}
				} else if (type === 'doubles') {
					const participant = playersArray?.find((p) => p.uid === node?.double_uid)
					let name = '---'
					let rating = null

					if (participant) {
						rating = participant?.rating ? participant?.rating : node?.name
						name = node?.name
					} else if (!node?.disabled && !node?.bye && !node?.double_uid) {
						name = node?.name
						rating = null
					} else if ((!node?.disabled && node?.bye) || (!node?.disabled && !node?.bye && node?.double_uid)) {
						name = '---'
						rating = '-'
					}

					formedNode = {
						doubleUid: node?.double_uid,
						nodeUid: node?.uid,
						type: node?.type,
						bye: node?.bye,
						disabled: node?.disabled,
						orderNumber: node?.order_number,
						rating,
						firstPlayerUid: participant?.player1?.uid ? participant?.player1?.uid : null,
						secondPlayerUid: participant?.player2?.uid ? participant?.player2?.uid : null,
						firstPlayerName: participant?.player1?.uid ? participant?.player1?.formedName : '',
						secondPlayerName: participant?.player2?.uid ? participant?.player2?.formedName : '',
						groupName: grp.name,
						name,
						noPlayer: !participant?.player1?.uid ? true : false
					}
				}

				formedNodesList.push(formedNode)

				return formedNode
			})
			return { ...grp, nodes: formedParticipants }
		})
		return { ...lvl, groups: newGroups }
	})

	const nodes = sortNodes(formedNodesList)
	const placedNodes = definePlacedPlayers(levels, nodes)

	return { levelsWithformedGroupsNodes: newLevels, sortedNodes: placedNodes }
}

export const sortNodes = (nodes) => {
	const sortedNodes = nodes.sort((a, b) => a.rating - b.rating)

	return sortedNodes
}

export const definePlacedPlayers = (levels, nodesList) => {
	const involvedPlayers = []

	levels?.map(lvl => {
		lvl?.groups?.map(grp => {
			grp?.nodes?.map(n => {
				involvedPlayers.push(n)

				return n
			})

			return grp
		})

		return lvl
	})

	const placedPlayers = nodesList?.map(n => {
		const matchedPlayer = involvedPlayers?.find(p => p?.nodeUid === n?.nodeUid || p?.uid === n?.nodeUid)
		const placed = matchedPlayer ? true : false

		return { ...n, placed: placed }
	})

	return placedPlayers
}

export const generateGroupName = (levels) => {
	const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'

	let count = 0
	levels?.map(lvl => {
		lvl?.groups?.map(grp => {
			count++
			return grp
		})
		return lvl
	})
	return alphabet[count]
}

export const dragItems = (result, levels) => {
	const sourceLevelIndex = result.source.droppableId.split('-')[0]
	const endLevelIndex = result.destination.droppableId.split('-')[0]

	const sourceGroupIndex = result.source.droppableId.split('-')[1]
	const finishGroupIndex = result.destination.droppableId.split('-')[1]

	const sourceGroup = { ...levels[sourceLevelIndex]?.groups[sourceGroupIndex] }
	const finishGroup = { ...levels[endLevelIndex]?.groups[finishGroupIndex] }

	const movedNode = {
		...levels[sourceLevelIndex]?.groups[sourceGroupIndex]?.nodes[result.source.index],
		groupName: finishGroup?.name
	}
	const replacedNode = {
		...levels[endLevelIndex]?.groups[finishGroupIndex]?.nodes[result.destination.index],
		groupName: sourceGroup?.name
	}

	return {
		sourceLevelIndex,
		endLevelIndex,
		finishGroupIndex,
		sourceGroupIndex,
		finishPlaceIndex: result.destination.index,
		sourcePlaceIndex: result.source.index,
		movedNode,
		replacedNode
	}
}

export const formNodesForRequest = (stage, editedLevels, type) => {
	const startNodes = []
	const editedNodes = []

	stage?.levels?.forEach(lvl => {
		lvl?.groups?.forEach(grp => {
			grp?.nodes?.forEach(n => {
				if (n?.type === 'incoming') {
					startNodes.push(n)
				}
			})
		})
	})

	editedLevels?.forEach(lvl => {
		lvl?.groups?.forEach(grp => {
			grp?.nodes?.forEach(n => {
				editedNodes.push(n)
			})
		})
	})

	const nodes = {
		nodes: []
	}

	startNodes?.forEach((startN, index) => {
		const editedNode = editedNodes[index]
		if (type === 'doubles') {
			nodes.nodes.push({ uid: startN.uid, double_uid: editedNode.doubleUid })
		} else {
			nodes.nodes.push({ uid: startN.uid, player_uid: editedNode.playerUid })
		}
	})

	return nodes
}

export const updateNodesList = (levels, currentList) => {
	const placedPlayers = []

	levels?.forEach(lvl => {
		lvl?.groups?.forEach(grp => {
			grp?.nodes?.forEach(n => {
				placedPlayers?.push({ ...n, groupName: grp?.name })
			})
		})
	})

	const updatedNodesList = currentList?.map(item => {
		const found = placedPlayers?.find(p => p?.nodeUid === item?.nodeUid)

		if (found) {
			return { ...item, groupName: found?.groupName }
		} else {
			return { ...item, groupName: null }
		}
	})

	return updatedNodesList
}

export const existingMatches = (stage) => {
	return (stage?.levels || []).some((lvl) =>
		(lvl?.groups || []).some((grp) =>
			(grp?.matches || []).some((m) => m?.sets?.length > 0)
		)
	)
}

export const checkFinishedMatches = (stage) => {
	if (stage?.rating_initial) {
		return !stage?.rating_initial.every((item) => item.player_uid || item?.double_uid)
	}
	return true
}
